<template>
  <div>
    <md-subheader class="survey__header">
      <!-- Show results -->
      <h4 class="title">Crear Encuesta</h4>
      <md-button class="md-simple" @click="openModalSurveyResults"><md-icon>insert_chart_outlined</md-icon> {{$t('games.survey.results.title')}}</md-button>  
    </md-subheader>
    <md-card-content>
      <md-field>
        <label for="template">{{$t("games.survey.template")}}</label>
        <md-select v-model="templateSelect" name="template" id="template">
          <md-option v-for="template in templates" :value="template.id" :key="template.id">{{template.name}}</md-option>
        </md-select>
      </md-field>

      <!-- Name -->
      <md-field :class="{'md-error': $v.surveyModel.name.$error && $v.surveyModel.name.$invalid, 'md-valid': !$v.surveyModel.name.$error && !$v.surveyModel.name.$invalid}">
        <label>{{$t('survey.create.name')}}</label>
        <md-input v-model.trim="$v.surveyModel.name.$model"></md-input>
        <slide-y-down-transition>
          <md-icon class="error" v-show="$v.surveyModel.name.$error && $v.surveyModel.name.$invalid">close</md-icon>
        </slide-y-down-transition>
        <slide-y-down-transition>
          <md-icon class="success" v-show="!$v.surveyModel.name.$error && !$v.surveyModel.name.$invalid">done</md-icon>
        </slide-y-down-transition>
      </md-field>
      <!-- Question Text -->
      <md-field :class="{'md-error': $v.surveyModel.questionText.$error && $v.surveyModel.questionText.$invalid, 'md-valid': !$v.surveyModel.questionText.$error && !$v.surveyModel.questionText.$invalid}">
        <label>{{$t('survey.create.questionText')}}</label>
        <md-input v-model.trim="$v.surveyModel.questionText.$model"></md-input>
        <slide-y-down-transition>
          <md-icon class="error" v-show="$v.surveyModel.questionText.$error && $v.surveyModel.questionText.$invalid">close</md-icon>
        </slide-y-down-transition>
        <slide-y-down-transition>
          <md-icon class="success" v-show="!$v.surveyModel.questionText.$error && !$v.surveyModel.questionText.$invalid">done</md-icon>
        </slide-y-down-transition>
      </md-field>
      <!-- Duration Seconds -->
      <md-field :class="{'md-error': $v.surveyModel.defaultDurationSeconds.$error && $v.surveyModel.defaultDurationSeconds.$invalid, 'md-valid': !$v.surveyModel.defaultDurationSeconds.$error && !$v.surveyModel.defaultDurationSeconds.$invalid}">
        <label>{{$t('survey.create.durationSeconds')}}</label>
        <md-input type="number" v-model.trim="$v.surveyModel.defaultDurationSeconds.$model"></md-input>
        <slide-y-down-transition>
          <md-icon class="error" v-show="$v.surveyModel.defaultDurationSeconds.$error && $v.surveyModel.defaultDurationSeconds.$invalid">close</md-icon>
        </slide-y-down-transition>
        <slide-y-down-transition>
          <md-icon class="success" v-show="!$v.surveyModel.defaultDurationSeconds.$error && !$v.surveyModel.defaultDurationSeconds.$invalid">done</md-icon>
        </slide-y-down-transition>
      </md-field>
      <!-- Answer 1 -->
      <md-field :class="{'md-error': $v.surveyModel.answerText01.$error && $v.surveyModel.answerText01.$invalid, 'md-valid': !$v.surveyModel.answerText01.$error && !$v.surveyModel.answerText01.$invalid}">
        <label>{{$t('survey.create.answer1')}}</label>
        <md-input v-model.trim="$v.surveyModel.answerText01.$model"></md-input>
        <slide-y-down-transition>
          <md-icon class="error" v-show="$v.surveyModel.answerText01.$error && $v.surveyModel.answerText01.$invalid">close</md-icon>
        </slide-y-down-transition>
        <slide-y-down-transition>
          <md-icon class="success" v-show="!$v.surveyModel.answerText01.$error && !$v.surveyModel.answerText01.$invalid">done</md-icon>
        </slide-y-down-transition>
      </md-field>
      <!-- Answer 2 -->
      <md-field :class="{'md-error': $v.surveyModel.answerText02.$error && $v.surveyModel.answerText02.$invalid, 'md-valid': !$v.surveyModel.answerText02.$error && !$v.surveyModel.answerText02.$invalid}">
        <label>{{$t('survey.create.answer2')}}</label>
        <md-input v-model.trim="$v.surveyModel.answerText02.$model"></md-input>
        <slide-y-down-transition>
          <md-icon class="error" v-show="$v.surveyModel.answerText02.$error && $v.surveyModel.answerText02.$invalid">close</md-icon>
        </slide-y-down-transition>
        <slide-y-down-transition>
          <md-icon class="success" v-show="!$v.surveyModel.answerText02.$error && !$v.surveyModel.answerText02.$invalid">done</md-icon>
        </slide-y-down-transition>
      </md-field>
      <!-- Answer 3 -->
      <md-field :class="{'md-error': $v.surveyModel.answerText03.$error && $v.surveyModel.answerText03.$invalid, 'md-valid': !$v.surveyModel.answerText03.$error && !$v.surveyModel.answerText03.$invalid}">
        <label>{{$t('survey.create.answer3')}}</label>
        <md-input v-model.trim="$v.surveyModel.answerText03.$model"></md-input>
        <slide-y-down-transition>
          <md-icon class="error" v-show="$v.surveyModel.answerText03.$error && $v.surveyModel.answerText03.$invalid">close</md-icon>
        </slide-y-down-transition>
        <slide-y-down-transition>
          <md-icon class="success" v-show="!$v.surveyModel.answerText03.$error && !$v.surveyModel.answerText03.$invalid">done</md-icon>
        </slide-y-down-transition>
      </md-field>
      <!-- Answer 4 -->
      <md-field :class="{'md-error': $v.surveyModel.answerText04.$error && $v.surveyModel.answerText04.$invalid, 'md-valid': !$v.surveyModel.answerText04.$error && !$v.surveyModel.answerText04.$invalid}">
        <label>{{$t('survey.create.answer4')}}</label>
        <md-input v-model.trim="$v.surveyModel.answerText04.$model"></md-input>
        <slide-y-down-transition>
          <md-icon class="error" v-show="$v.surveyModel.answerText04.$error && $v.surveyModel.answerText04.$invalid">close</md-icon>
        </slide-y-down-transition>
        <slide-y-down-transition>
          <md-icon class="success" v-show="!$v.surveyModel.answerText04.$error && !$v.surveyModel.answerText04.$invalid">done</md-icon>
        </slide-y-down-transition>
      </md-field>
      <!-- Answer 4 -->
      <md-field :class="{'md-error': $v.surveyModel.code.$error && $v.surveyModel.code.$invalid, 'md-valid': !$v.surveyModel.code.$error && !$v.surveyModel.code.$invalid}">
        <label>{{$t('survey.create.code')}}</label>
        <md-input v-model.trim="$v.surveyModel.code.$model"></md-input>
        <slide-y-down-transition>
          <md-icon class="error" v-show="$v.surveyModel.code.$error && $v.surveyModel.code.$invalid">close</md-icon>
        </slide-y-down-transition>
        <slide-y-down-transition>
          <md-icon class="success" v-show="!$v.surveyModel.code.$error && !$v.surveyModel.code.$invalid">done</md-icon>
        </slide-y-down-transition>
      </md-field>
        
      <md-button class="md-block md-success" @click="sendSurvey()">{{$t("games.survey.send")}}</md-button>
    </md-card-content>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { required, email, sameAs } from 'vuelidate/lib/validators';
import { SlideYDownTransition } from "vue2-transitions";

export default {
  components: {
    SlideYDownTransition
  },
  props: {
    gameId: Number,
    teamId: Number
  },
  data() {
    return {
      templateSelect: "",
      surveyModel: {
        name: "",
        questionText: "",
        defaultDurationSeconds: null,
        answerText01: null,
        answerText02: null,
        answerText03: null,
        answerText04: null,
        code: null
      },
      surveyFinished: []
    }
  },
  computed: {
    ...mapState({
      templates: state => state.SurveyModule.templates
    })
  },
  methods: {
    async sendSurvey() {
      const params = {
        gameId: this.gameId,
        teamId: this.teamId,
        questionText: this.surveyModel.questionText,
        durationSeconds: this.surveyModel.defaultDurationSeconds,
        answerText01: this.surveyModel.answerText01,
        answerText02: this.surveyModel.answerText02,
        answerText03: this.surveyModel.answerText03,
        answerText04: this.surveyModel.answerText04,
        code: this.surveyModel.code
      }
      const request = await this.$store.dispatch('createSurvey', params)
      if (request != undefined) {
        this.templateSelect = ""
        this.$v.$reset();
        this.surveyModel = {
          name: "",
          questionText: "",
          defaultDurationSeconds: null,
          answerText01: null,
          answerText02: null,
          answerText03: null,
          answerText04: null,
          code: null
        }
        this.$notify({
          message: this.$t(`notifications.game.sendSurvey`),
          icon: 'add_alert',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'success'
        })
      } else {
        this.$store.dispatch("openModalError")
      }
    },
    openModalSurveyResults() {
      this.$store.dispatch("openModalResultSurvet", {
        active: true,
        gameId: this.gameId,
        teamId: this.teamId
      })
    }
  },
  watch: {
    templateSelect() {
      this.surveyModel = this.templates.find(template => template.id == this.templateSelect)
    }
  },
  validations: {
    surveyModel: {
      name: {
        required
      },
      questionText: {
        required
      },
      defaultDurationSeconds: {
        required
      },
      answerText01: {
        required
      },
      answerText02: {
        required
      },
      answerText03: {
        required
      },
      answerText04: {},
      code: {}
    },
  }
}
</script>

<style>
.collapse-results {
  border: 1px solid #606060;
  padding: 8px;
  border-radius: 4px;
  background: #bcbcbc2e;
}

.collapse-results .md-toolbar {
  padding-top: 0!important ;
  min-height: 32px;
}

.collapse-results .md-toolbar span {
  width: 100%;
}

.md-subheading {
  cursor: pointer;
}

.survey__header {
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
}

.survey__header h4 {
    font-weight: bold;
}

.modal-container {
  max-width: 1000px;
}

.md-table-cell {
  text-align: left;
}

.md-card {
  z-index: 0;
}


</style>